module.exports = __webpack_public_path__ + "img/patrick.000f76d4.png";